export const SOCIETE_BRAND = {
  iticonseil: {
    label: 'Iticonseil',
    headerClass: 'bg-orange text-white',
    cellClass: 'bg-orange-50',
    badgeClass: 'bg-orange text-white',
  },
  koikispass: {
    label: 'Koikispass',
    headerClass: 'bg-danger-600 text-white',
    cellClass: 'bg-danger-50',
    badgeClass: 'bg-danger-600 text-white',
  },
  autre: {
    label: 'Autre',
    headerClass: 'bg-secondary text-white',
    cellClass: '',
    badgeClass: 'bg-secondary text-white',
  },
};

export function getSocieteBrand(societe) {
  return SOCIETE_BRAND[societe] || SOCIETE_BRAND.autre;
}
